import PropTypes from "prop-types";
import "../../../src/assets/scss/personal_detail.scss";
import twitterIcon from "../../assets/img/icons/twitter.png";
import instaIcon from "../../assets/img/icons/instagram.png";
import facebookIcon from "../../assets/img/icons/facebook.png";
import dribbleIcon from "../../assets/img/icons/dribble.png";
import vimeoIcon from "../../assets/img/icons/vimeo.png";
import youtubeIcon from "../../assets/img/icons/youtube.png";
import behanceIcon from "../../svg/behance.svg";
import mediumIcon from "../../svg/medium.svg";
import canvaIcon from "../../svg/canva.svg";
import Input from "../commonComponents/Input";
import disable_link from "../../svg/disable-link.svg";
import active_link from "../../svg/active-link.svg";
import { Modal } from "react-bootstrap";
import { useState } from "react";
import Button from "../common/Button";
import "bootstrap-icons/font/bootstrap-icons.css";

const SocialPresence = (props) => {
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const [arrayPresence, setArrayPresence] = useState([
    {
      index: 0,
      name: "Behance",
      imgLink: behanceIcon,
      professionalKey: "behance",
      selected: false,
    },
    {
      index: 1,
      name: "Medium",
      imgLink: mediumIcon,
      professionalKey: "medium",
      selected: false,
    },
    {
      index: 2,
      name: "Canva",
      imgLink: canvaIcon,
      professionalKey: "canva",
      selected: false,
    },
  ]);

  const [show, setShow] = useState(false);
  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);
  const {
    urlErrors,
    profileDetails,
    setProfileDetails,
    handleChange,
    handleSocialChange = () => {},
    disabled,
    handleSubmit,
  } = props;

  const onMultiSelectHandler = (pos) => {
    let selected = [...arrayPresence];
    selected[pos].selected = !selected[pos].selected;
    setArrayPresence(selected);
  };

  const onAddPresenceHandler = () => {
    const selected = arrayPresence
      .filter((ap) => ap.selected)
      .map((ap) => ({
        image: ap.imgLink,
        professionalKey: ap.professionalKey,
        link: "",
        subscribe: false,
        linkName: ap.name,
      }));
    const modified = [...profileDetails?.professionalPresence, ...selected];
    setProfileDetails((pd) => ({ ...pd, professionalPresence: modified }));
    setArrayPresence((ap) => ap.map((a) => ({ ...a, selected: false })));
    handleClose();
  };

  const getUrlValue = (type = "") => {
    const record  = profileDetails.socialLinks?.find(a => a.professionalKey === type) || {};
    return record.link
  }

  const getIsSubscribe = (type = "") => {
    const record  = profileDetails.socialLinks?.find(a => a.professionalKey === type) || {};
    return record.subscribe
  }

  return (
    <div class="boxCover">
      <div class="fieldSet pt-0 border-0">
        <h2 class="mb-4 titleText">
          Your Social Presence <small class="showOpt">Show Publicly</small>
        </h2>
        <ul class="presenceList pt-1">
          <li class="presenceItem">
            <div class="presenceName">
              <span class="presenceIcon">
                <img src={twitterIcon} alt="#" />
              </span>{" "}
              Twitter
            </div>
            <div class="presenceUrl">
              <div class="fieldWrap">
                <div class="fieldCover">
                  <img
                    src={profileDetails?.twitter ? active_link : disable_link}
                    className="pre-icon"
                    alt="link"
                  />
                  <Input
                    className={"fieldForm"}
                    type="text"
                    name="twitter"
                    placeholder="Add link"
                    value={getUrlValue('twitter')}
                    handleChange={(e) => handleSocialChange(e)}
                  />
                  <p className="url_error">{urlErrors.twitter}</p>
                </div>
              </div>
            </div>
            <div class="presenceView text-center">
              <div class="form-check form-switch d-inline-flex mb-0">
                <input class="form-check-input" type="checkbox" name="twitter" onChange={(e) => handleSocialChange(e)} checked={getIsSubscribe('twitter')}/>
              </div>
            </div>
          </li>
          <li class="presenceItem">
            <div class="presenceName">
              <span class="presenceIcon">
                <img src={instaIcon} alt="#" />
              </span>{" "}
              Instagram
            </div>
            <div class="presenceUrl">
              <div class="fieldWrap">
                <div class="fieldCover">
                  <img
                    src={profileDetails?.instagram ? active_link : disable_link}
                    className="pre-icon"
                    alt="link"
                  />
                  {/* <b class="icon-link"></b> */}
                  {/* <input class="fieldForm" type="url" /> */}
                  <Input
                    className={"fieldForm"}
                    type="text"
                    name="instagram"
                    placeholder="Add link"
                    value={getUrlValue('instagram')}
                    handleChange={(e) => handleSocialChange(e)}
                  />
                  <p className="url_error">{urlErrors.instagram}</p>
                </div>
              </div>
            </div>
            <div class="presenceView text-center">
              <div class="form-check form-switch d-inline-flex mb-0">
                <input class="form-check-input" type="checkbox" name="instagram" onChange={(e) => handleSocialChange(e)} checked={getIsSubscribe('instagram')} />
              </div>
            </div>
          </li>
          <li class="presenceItem">
            <div class="presenceName">
              <span class="presenceIcon">
                <img src={facebookIcon} alt="#" />
              </span>{" "}
              Facebook
            </div>
            <div class="presenceUrl">
              <div class="fieldWrap">
                <div class="fieldCover">
                  <img
                    src={profileDetails?.facebook ? active_link : disable_link}
                    className="pre-icon"
                    alt="link"
                  />
                  {/* <input class="fieldForm" type="url" /> */}
                  <Input
                    className={"fieldForm"}
                    type="text"
                    name="facebook"
                    placeholder="Add link"
                    value={getUrlValue('facebook')}
                    handleChange={(e) => handleSocialChange(e)}
                  />
                  <p className="url_error">{urlErrors.facebook}</p>
                </div>
              </div>
            </div>
            <div class="presenceView text-center">
              <div class="form-check form-switch d-inline-flex mb-0">
                <input class="form-check-input" type="checkbox" name="facebook" onChange={(e) => handleSocialChange(e)} checked={getIsSubscribe('facebook')}/>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="fieldSet ">
        <h2 class="mb-4 mt-2 titleText">Your Professional Presence</h2>
        <ul class="presenceList pt-1">
          {profileDetails?.professionalPresence &&
            profileDetails?.professionalPresence.map((item, index) => {
              return (
                <li class="presenceItem">
                  <div class="presenceName">
                    <span class="presenceIcon">
                      <img src={item.image} alt="#" />
                    </span>{" "}
                    {item.linkName}
                  </div>
                  <div class="presenceUrl">
                    <div class="fieldWrap">
                      <div class="fieldCover">
                        <img
                          src={item.link ? active_link : disable_link}
                          className="pre-icon"
                          alt="link"
                        />
                        {/* <input class="fieldForm" type="url" /> */}
                        <Input
                          className={"fieldForm"}
                          type="text"
                          name={item.professionalKey}
                          placeholder={`Add link`}
                          value={item.link}
                          handleChange={(e) =>
                            handleChange(e, "professionalPresence", "link")
                          }
                        />
                        <p className="url_error">{item.error}</p>
                      </div>
                    </div>
                  </div>
                  <div class="presenceView text-center">
                    <div class="form-check form-switch d-inline-flex mb-0">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name={`${item.professionalKey}`}
                        checked={item?.subscribe}
                        onChange={(e) =>
                          handleChange(e, "professionalPresence", "subscribe")
                        }
                      />
                    </div>
                  </div>
                </li>
              );
            })}
        </ul>
        {profileDetails?.professionalPresence?.length >= 6 ? null : (
          <div class="fieldMore px-1">
            <a onClick={handleOpen}>+ Add Another</a>
          </div>
        )}
      </div>
      <Modal
        className="modal-container"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header style={{ border: "none" }} closeButton>
          <Modal.Title className="modal-title">
            Add Another Platform
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="modal-body">
          <div>
            <div
              className="outer-presence"
              onClick={() => setDropDownOpen(!dropDownOpen)}
            >
              <input
                type="text"
                placeholder="Choose Your Presence"
                disabled="true"
              />
              <span>
                {dropDownOpen ? (
                  <i
                    className="bi bi-chevron-up"
                    onClick={() => setDropDownOpen(false)}
                  ></i>
                ) : (
                  <i
                    className="bi bi-chevron-down"
                    onClick={() => setDropDownOpen(true)}
                  ></i>
                )}
              </span>
            </div>
            {dropDownOpen ? (
              <div className="presence-box">
                {arrayPresence.map((data) => {
                  if (
                    profileDetails?.professionalPresence?.find(
                      (ele) => ele?.professionalKey === data?.professionalKey
                    ) === undefined
                  ) {
                    return (
                      <div key={data.index} className="row-items">
                        <input
                          type="checkbox"
                          checked={data.selected}
                          onChange={() => onMultiSelectHandler(data.index)}
                        />
                        <img src={data.imgLink} />
                        <div
                          className="presence-name"
                          onClick={() => onMultiSelectHandler(data.index)}
                        >
                          {data.name}
                        </div>
                      </div>
                    );
                  } else {
                    return null;
                  }
                })}
              </div>
            ) : null}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button handleClick={() => onAddPresenceHandler()} title="Add" />
        </Modal.Footer>
      </Modal>
    </div>
  );
};
SocialPresence.propTypes = {
  // profileDetails: PropTypes.shape({
  //     vimeo: PropTypes.string,
  //     facebook: PropTypes.string,
  //     instagram: PropTypes.string,
  //     twitter: PropTypes.string,
  //     dribble: PropTypes.string,
  //     professionalPresence:PropTypes.array,
  // }),
  handleChange: PropTypes.func,
  disabled: PropTypes.bool,
  handleSubmit: PropTypes.func,
};

SocialPresence.defaultProps = {
  handleChange: () => null,
  // profileDetails: {professionalPresence:[{}]},
  disabled: false,
  handleSubmit: () => null,
};

export default SocialPresence;
